import { jsx as _jsx } from "react/jsx-runtime";
import "@google/model-viewer";
import React from "react";
const ModelViewer = /* @__PURE__ */ (() => React.forwardRef(function Model_Viewer({ src, alt, poster, style, className }, ref) {
    return (_jsx("div", { style: { ...style }, className: className, ref: ref, children: src ? (
        // @ts-expect-error - model-viewer is not a standard HTML element
        _jsx("model-viewer", { src: src, alt: alt || "3D Model", "camera-controls": true, poster: poster ? poster : null, style: { width: "100%", height: "100%" } })) : null }));
}))();
export default ModelViewer;
//# sourceMappingURL=ModelViewer.js.map